(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const initialize = (root = document) => {
      root.querySelectorAll('.nz-footer__grid').forEach((grid) => {
        Array.from(grid.children).slice(1).forEach((column, index) => {
          const heading = column.querySelector(':scope > h4');
          if (!heading || column.dataset.nzMobileFooterReady) return;
          column.dataset.nzMobileFooterReady = 'true';
          const originalHeading = Array.from(heading.childNodes);
          const originalContent = Array.from(column.childNodes).filter((node) => node !== heading);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'nz-footer__toggle';
          button.textContent = heading.textContent;
          const chevron = document.createElement('span');
          chevron.className = 'nz-footer__chevron';
          chevron.setAttribute('aria-hidden', 'true');
          button.append(chevron);
          const panel = document.createElement('div');
          panel.className = 'nz-footer__panel';
          panel.id = `${grid.closest('[id]')?.id || 'nz-footer'}-panel-${index}`;
          button.setAttribute('aria-controls', panel.id);
          button.setAttribute('aria-expanded', 'false');
          let expanded = false;
          let active = false;
          const sync = () => {
            if (mobile.matches && !active) {
              heading.replaceChildren(button);
              heading.classList.add('nz-footer__mobile-heading');
              originalContent.forEach((node) => panel.append(node));
              column.append(panel);
              panel.hidden = !expanded;
              active = true;
            } else if (!mobile.matches && active) {
              heading.replaceChildren(...originalHeading);
              heading.classList.remove('nz-footer__mobile-heading');
              originalContent.forEach((node) => column.append(node));
              panel.remove();
              active = false;
            }
          };
          button.addEventListener('click', () => {
            expanded = !expanded;
            button.setAttribute('aria-expanded', String(expanded));
            panel.hidden = !expanded;
          });
          mobile.addEventListener('change', sync);
          sync();
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
